import React, { useState } from "react";
import { createEmptyNodeInput, NumberInputUtils, richToPlain } from "api-sdk";
import { renderNumberInputConstraints } from "reader-common";
import { ChatReaderComponentProps } from "../types";

export function NumberInput(props: ChatReaderComponentProps<"NUMBER">) {

    const [ inputText, setInputText ] = useState(props.value != null ? String(props.value.number) : "")

    function handleInputChange(input: string) {
        setInputText(NumberInputUtils.cleanInput(input, props.inputField.integersOnly))

        // Check valid input
        const number = NumberInputUtils.parseNumber(input)

        props.onChange(
            number != undefined && NumberInputUtils.validateInput(props.inputField, number).valid
                ? NumberInputUtils.asNodeInput(number)
                : createEmptyNodeInput()
        )
    }

    const inputLabel = richToPlain(props.inputField.label || props.config.messages.inputNumber)

    return (
        <div className="number-field chat-surface input-target">
            <input
                pattern="[0-9,]*"
                value={ inputText }
                placeholder={ inputLabel }
                title={ inputLabel }
                autoFocus={ props.autoFocus }
                onChange={ e => handleInputChange(e.target.value || "") }
            />
            { renderNumberInputConstraints(props.inputField, inputText, props.config) }
        </div>
    )

}